import styled from 'styled-components';
import { useState } from 'react';
import { DropdownTrigger } from '../dropdowns/DropdownTrigger';
import {
  getTimeStamps,
  getUpcomingRange,
  getYearsFromRange,
  getYearsRanges,
} from './utils/gridUtils';
import { Slider } from '../Slider';

const getSliderRange = (data: any) => {
  const currentYear = new Date().getFullYear();
  const min = Math.min(...data.map((item: any) => Number.parseInt(item.name, 10)));
  const max = Math.max(...data.map((item: any) => Number.parseInt(item.name, 10)));
  return [Math.min(min, currentYear), Math.max(currentYear + 1, max)];
};

export const YearsFilter = ({
  data,
  currentSelection,
  toggleSelection,
  setCurrentSelection,
}: {
  data: any;
  toggleSelection: any;
  setCurrentSelection: any;
  currentSelection: any;
}) => {
  const filterData: any = data.filter((item: any) => {
    return item.name && Number.parseInt(item.name || '0', 10) >= 1970;
  });
  const [isSliderValue, setIsSliderValue] = useState(true);
  const sliderRange = getSliderRange(filterData);
  const multiSelectRanges = getYearsRanges(sliderRange[1]);
  const upcomingRange = getUpcomingRange();

  // console.log(upcomingRange);

  const getDisplayDate = (date: any) => {
    const currentYear = new Date().getFullYear();
    if (date.start === currentYear) {
      return `${date.start} and later`;
    }
    if (date.end === 1985) {
      return `${date.end} and earlier`;
    }
    if (date.start === date.end) {
      return `${date.start}`;
    }

    return `${date.start} - ${date.end}`;
  };

  const onSliderChange = (values: any) => {
    if (isSliderValue === true) {
      setIsSliderValue(true);
      setCurrentSelection(
        new Set([
          `${getTimeStamps({ year: values[0] })}-${getTimeStamps({
            year: values[1],
          })}`,
        ]),
      );
    }
  };

  const selectedYearRange = getYearsFromRange([...currentSelection][0] || '');

  return (
    <div className="tw-pt-4">
      {currentSelection.size > 1 && !isSliderValue ? (
        <YearsFilter.MultipleRangesSelected>
          Multiple Ranges Selected
        </YearsFilter.MultipleRangesSelected>
      ) : (
        <YearsFilter.YearSliderKeys>
          <span>{selectedYearRange.start || selectedYearRange.end || sliderRange[0]}</span>
          <span>
            {selectedYearRange.end || selectedYearRange.start || sliderRange[1]}
            {!selectedYearRange.end && selectedYearRange.start && '+'}
          </span>
        </YearsFilter.YearSliderKeys>
      )}
      <YearsFilter.SliderWrapper>
        {currentSelection.size > 1 && !isSliderValue ? (
          <YearsFilter.Line />
        ) : (
          <Slider
            data-qa="year_filter_slider"
            handleSlideEnd={(val) => {
              setIsSliderValue(true);
              onSliderChange(val);
            }}
            handleUpdate={onSliderChange}
            values={[
              selectedYearRange?.start || selectedYearRange.end || sliderRange[0],
              selectedYearRange.end || selectedYearRange.start || sliderRange[1],
            ]}
            step={1}
            range={[sliderRange[0], sliderRange[1]]}
          />
        )}
      </YearsFilter.SliderWrapper>

      {/* buttons ranges */}
      <div className="tw-box-border">
        {Object.keys(multiSelectRanges).map((yearRange) => {
          return (
            <DropdownTrigger
              dataQa="mobile_filter_year_button"
              key={yearRange}
              title={getDisplayDate(multiSelectRanges[yearRange])}
              onClick={() => {
                if (currentSelection.has(upcomingRange.value) || isSliderValue) {
                  setCurrentSelection(new Set([yearRange]));
                  if (isSliderValue) {
                    setIsSliderValue(false);
                  }
                } else {
                  toggleSelection({ name: yearRange });
                }
              }}
              isSelected={currentSelection.has(yearRange)}
              height={22}
            />
          );
        })}
        {/* upcoming button */}
        <DropdownTrigger
          dataQa="mobile_filter_year_button"
          onClick={() => {
            setCurrentSelection(new Set([upcomingRange.value]));
          }}
          isSelected={currentSelection.has(upcomingRange.value)}
          title="Upcoming Releases"
          height={22}
        />
      </div>
    </div>
  );
};

YearsFilter.Line = styled.hr`
  background-color: #000000;
  opacity: 1;
`;

YearsFilter.MultipleRangesSelected = styled.div`
  text-align: center;
`;

YearsFilter.YearSliderKeys = styled.div`
  display: flex;
  justify-content: space-between;
`;

YearsFilter.SliderWrapper = styled.div`
  margin: 24px 8px;
  padding: 0 8px;
`;
